import jwtAxios from "axios";

const jwtAuthAxiosKiosk = jwtAxios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

jwtAuthAxiosKiosk.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.message === "Unauthorised access") {
      delete jwtAuthAxiosKiosk.defaults.headers.common["Authorization"];
      import("@jumbo/components/JumboAuthProvider/authHelpers")
        .then((m) => m.removeAuth?.())
        .catch(() => {
          try {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
          } catch (_e) {}
          try {
            sessionStorage.removeItem("token");
          } catch (_e) {}
        });
    }
    return Promise.reject(err);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    jwtAuthAxiosKiosk.defaults.headers.common["Authorization"] =
      "Bearer " + token;
    sessionStorage.setItem("token", token);
  } else {
    delete jwtAuthAxiosKiosk.defaults.headers.common["Authorization"];
    sessionStorage.removeItem("token");
  }
};

export const getAuthToken = () => {
  return sessionStorage.getItem("token");
};

//todo: define interceptors and other configuration like baseURL, headers etc. here
export default jwtAuthAxiosKiosk;
